export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11326.8b28937a.jpg";